import React, { useEffect, useState } from "react";
import Paper from "@mui/material/Paper";
import Box from "@mui/material/Box";
import { Button, TablePagination } from "@mui/material";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import InputBase from "@mui/material/InputBase";
import IconButton from "@mui/material/IconButton";
import SearchIcon from "@mui/icons-material/Search";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import ViewModal from "../ViewModal"; // Updated to use ViewModal
import createInstance from "../../../api/axiosinstance";
import EditIcon from "@mui/icons-material/Edit";

const ListInterview = ({ onOpenAddOrganization }) => {
  const [searchTerm, setSearchTerm] = useState("");
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(5);
  const [interviewList, setInterviewList] = useState([]);
  const [isViewModalOpen, setIsViewModalOpen] = useState(false);
  const [selectedInterview, setSelectedInterview] = useState(null);
  const aiDishaApi = createInstance("DISHA");
  const organizationId = window.sessionStorage.getItem("organizationId");

  useEffect(() => {
    getInterviewList();
  }, []);

  const getInterviewList = async () => {
    console.log("BEFORE API CALL");
    await aiDishaApi
      .get(`/get_Scheduled_interviews_detail?organization_id=${organizationId}`)
      .then((response) => {
        console.log("interviews", response.data);
        const reversedData = Array.isArray(response.data) ? [...response.data].reverse() : [];
      setInterviewList(reversedData);
      console.log("interviews", reversedData);
      })
      .catch((error) => {
        console.log("Error fetching the interviews", error);
      });
  };

  const handleSearch = (event) => {
    setSearchTerm(event.target.value);
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const handleViewModalOpen = (interview) => {
    setSelectedInterview(interview);
    setIsViewModalOpen(true);
  };

  const handleViewModalClose = () => {
    setIsViewModalOpen(false);
    setSelectedInterview(null); // Clear selected interview on close
  };

  const header = [
    {
      interviewId: "Interview ID",
      candidateName: "Candidate Name",
      appliedPosition: "Applied Position",
      interviewDate: "Interview Date",
      status: "Interview Status",
      action: "Action",
    },
  ];

  const formatDateTime = (interview) => {
    let dateTimeField;
  
    switch (interview.round) {
      case "HR":
        dateTimeField = interview["HR interview_date_and_time"];
        break;
      case "Managerial":
        dateTimeField = interview["Managerial interview_date_and_time"];
        break;
      case "Technical Round 1":
      case "Technical Round 2":
        dateTimeField = interview["interview_date_and_time"];
        break;
      default:
        dateTimeField = interview["interview_date_and_time"];
    }
  
    if (!dateTimeField) {
      return "Invalid Date";
    }
  
    const date = new Date(dateTimeField);
  
    if (isNaN(date.getTime())) {
      return "Invalid Date";
    }
  
    // Convert UTC to IST by adding 5:30 hours (5.5 hours in milliseconds)
    const istDate = new Date(date.getTime() + 5.5 * 60 * 60 * 1000);
  
    // Format the date and time in IST
    const formattedDate = istDate.toLocaleDateString("en-US", {
      year: "numeric",
      month: "2-digit",
      day: "2-digit",
    });
    const formattedTime = istDate.toLocaleTimeString("en-US", {
      hour: "2-digit",
      minute: "2-digit",
      hour12: false,
    });
  
    return `${formattedDate} - ${formattedTime}`;
  };

  const filteredInterviews = interviewList.filter((row) =>
    row.job_title?.toLowerCase().includes(searchTerm.toLowerCase())
  );

  console.log("Actual Interviews", interviewList);
  console.log("Filtered Interviews", filteredInterviews);

  const handleEditClick = (interview) => {
    handleViewModalOpen(interview);
    console.log("Editing interview:", interview);
  };

  return (
    <div>
      <Box
        display="grid"
        gridTemplateColumns="repeat(12, 1fr)"
        sx={{
          marginTop: "auto",
          alignItems: "center",
          borderRadius: "10px",
          padding: "1% 1%",
        }}
      >
        <Box gridColumn="span 12" sx={{ marginTop: "auto", textAlign: "left", marginBottom: "0%" }}>
          <Typography
            sx={{ fontFamily: "poppins", fontSize: "28px", color: "#033538" }}
          >
            List Interview
          </Typography>
        </Box>
        <Box gridColumn="span 6" sx={{ marginTop: "auto", textAlign: "left", marginBottom: "2%", marginLeft: "8%" }}>
          <Paper sx={{ p: "2px 4px", display: "flex", width: "75%", borderRadius: 2, backgroundColor: "#033538" }}>
            <IconButton type="button" sx={{ p: "8px", color: "white" }} aria-label="search">
              <SearchIcon />
            </IconButton>
            <InputBase
              sx={{ ml: 1, flex: 1, fontFamily: "Poppins", color: "white" }}
              placeholder="Search by Applied Position"
              inputProps={{ "aria-label": "search google maps" }}
              value={searchTerm}
              onChange={handleSearch}
            />
          </Paper>
        </Box>
      </Box>
      <Box xs={1} sx={{ backgroundColor: "#33333" }}>
        <Grid container spacing={1} sx={{ justifyContent: "center" }}>
          <Grid item xs={10}>
            <TableContainer
              component={Paper}
              sx={{
                marginTop: "25px",
                borderRadius: "10px",
              }}
            >
              <Table size="small">
                <TableHead sx={{ backgroundColor: "#033538" }}>
                  {header.map((head) => (
                    <TableRow key={head.interviewId}>
                      <TableCell sx={{ color: "white", borderBottom: 0, borderLeft: "1px solid black" }}>
                        {head.interviewId}
                      </TableCell>
                      <TableCell sx={{ color: "white", borderBottom: 0 }}>
                        {head.candidateName}
                      </TableCell>
                      <TableCell sx={{ color: "white", borderBottom: 0 }}>
                        {head.appliedPosition}
                      </TableCell>
                      <TableCell sx={{ color: "white", borderBottom: 0 }}>
                        {head.interviewDate}
                      </TableCell>
                      <TableCell sx={{ color: "white", borderBottom: 0 }}>
                        {head.status}
                      </TableCell>
                      <TableCell sx={{ color: "white", borderBottom: 0 }}>
                        {head.action}
                      </TableCell>
                    </TableRow>
                  ))}
                </TableHead>
                <TableBody>
                  {filteredInterviews &&
                    filteredInterviews
                      .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                      .map((interview) => (
                        <TableRow
                          key={interview.interview_id}
                          sx={{ backgroundColor: "#006A71", marginRight: "30px" }}
                        >
                          <TableCell sx={{ color: "white", border: "1px solid black" }}>
                            {interview.interview_id}
                          </TableCell>
                          <TableCell sx={{ color: "white", border: "1px solid black" }}>
                            {interview.candidate_name}
                          </TableCell>
                          <TableCell sx={{ color: "white", border: "1px solid black" }}>
                            {interview.job_title}
                          </TableCell>
                          <TableCell sx={{ color: "white", border: "1px solid black" }}>
                            {formatDateTime(interview)}
                          </TableCell>
                          <TableCell sx={{ color: "white", border: "1px solid black" }}>
                            {interview.round}
                          </TableCell>
                          <TableCell sx={{ color: "white", border: "1px solid black" }}>
                            <Button
                              variant="contained"
                              size="small"
                              startIcon={<EditIcon />}
                              onClick={() => handleEditClick(interview)}
                              sx={{
                                backgroundColor: "#033538",
                                color: "white",
                                "&:hover": {
                                  backgroundColor: "#02484b",
                                },
                                fontFamily: "Poppins",
                                textTransform: "none",
                              }}
                            >
                              Edit
                            </Button>
                          </TableCell>
                        </TableRow>
                      ))}
                </TableBody>
              </Table>
              <TablePagination
                rowsPerPageOptions={[5, 10, 15]}
                component="div"
                count={filteredInterviews.length}
                rowsPerPage={rowsPerPage}
                page={page}
                onPageChange={handleChangePage}
                onRowsPerPageChange={handleChangeRowsPerPage}
                sx={{ backgroundColor: "#033538", color: "white" }}
              />
            </TableContainer>
          </Grid>
        </Grid>
      </Box>
      <ViewModal
        isOpen={isViewModalOpen}
        onClose={handleViewModalClose}
        title="Edit Interview"
        interview={selectedInterview}
        onUpdate={getInterviewList} // Pass getInterviewList to refresh table
      />
    </div>
  );
};

export default ListInterview;